import { useContext, useEffect, useState } from 'react';
import { getPreferenceProperty } from '@wayste/client-utils';
import invariant from 'ts-invariant';
import { getWaysteContext } from '../context/WaysteContext';
/**
 * Loads the acting hauler's preferences (Sourgum in admin-portal, the selected
 * hauler in wayste). Backed by GET /hauler/preferences, which resolves the
 * hauler from the auth token. Use `getFlag` for boolean feature gates.
 */
export function useHaulerPreferences(override) {
    const context = useContext(getWaysteContext());
    const client = override || context.client;
    invariant(!!client, 'useHaulerPreferences: missing WaysteClient (wrap in <WaysteProvider> or pass an instance).');
    const [preferences, setPreferences] = useState([]);
    const [loading, setLoading] = useState(true);
    const load = async () => {
        setLoading(true);
        try {
            setPreferences(await client.hauler().wayste.preferences.query());
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        void load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client]);
    const getFlag = (key) => getPreferenceProperty(preferences, key) === true;
    return { preferences, loading, getFlag, refresh: load };
}
//# sourceMappingURL=useHaulerPreferences.js.map